import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { RunnerLoading } from "./runner-loading";

type LoadingVariant = 'spinner' | 'skeleton' | 'pulse' | 'dots';

interface LoadingStateProps {
  variant?: LoadingVariant;
  text?: string;
  fullScreen?: boolean;
  className?: string;
}

export const LoadingState = ({ 
  variant = 'spinner',
  text,
  fullScreen = false,
  className 
}: LoadingStateProps) => {
  const Spinner = () => (
    <div className="flex flex-col items-center justify-center gap-3">
      <Loader2 className="w-8 h-8 animate-spin text-primary" />
      {text && <p className="text-sm text-muted-foreground">{text}</p>}
    </div>
  );

  const Skeleton = () => (
    <div className="space-y-3">
      <div className="h-4 bg-muted rounded animate-pulse" />
      <div className="h-4 bg-muted rounded animate-pulse w-3/4" />
      <div className="h-4 bg-muted rounded animate-pulse w-1/2" />
    </div>
  );

  const Pulse = () => (
    <div className="w-12 h-12 bg-primary/20 rounded-full animate-pulse-soft" />
  );

  const Dots = () => (
    <div className="flex gap-2">
      <div className="w-3 h-3 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
      <div className="w-3 h-3 bg-primary rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
      <div className="w-3 h-3 bg-primary rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
    </div>
  );

  const variants = {
    spinner: <Spinner />,
    skeleton: <Skeleton />,
    pulse: <Pulse />,
    dots: <Dots />
  };

  const content = variants[variant];

  if (fullScreen) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <RunnerLoading text={text} />
      </div>
    );
  }

  return <div className={cn("py-8", className)}>{content}</div>;
};
